import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { BsModalService } from 'ngx-bootstrap';
import { BaseComponent } from 'app/components/base.component';
import { ModalType } from 'app/components/modals/modal.const';
import { FormFieldType } from 'app/components/modals/modal-form-template/modal-form.const';
import {
  GetSummaryQuery,
  QCSummaryAgent,
  QCSummaryCall,
  QCSummaryEmotion,
  SmartQcService,
  ViewQCSummaryCall,
  ViewQCSummaryEmotion,
} from 'app/common/services/SmartQC.service';
import { Observable } from 'rxjs';
import {
  buildQCSummaryCall,
  FormFieldCode,
  ModalAction,
  buildViewQCSummaryEmotion,
  buildTableColumnsSummaryAgent,
} from './summary.util';
import { sumBy, round } from 'lodash';

@Component({
  selector: 'app-smart-qc-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.css'],
  providers: [SmartQcService],
})
export class SummaryComponent extends BaseComponent implements OnInit {
  @ViewChild('template') template: ElementRef;
  public loading: boolean = true;
  public modalAction: ModalAction = 'close';
  public viewQCSummaryCall: ViewQCSummaryCall;
  public viewQcSummaryEmotion: ViewQCSummaryEmotion[] = [];
  public qcSummaryAgent: QCSummaryAgent[] = [];
  public tableColumnsSummaryAgent = [];
  public emotionChartOptions: any = {};
  public colorsOptionsSourceName: any = [
    '#099516',
    '#ffd061',
    '#05027c',
    '#096c86',
    '#706f6f',
    '#c5c7cd',
    '#a2ecff',
    '#ffd9d9',
    '#ff4240',
    '#000000',
  ];

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService,
    private smartQCService: SmartQcService
  ) {
    super(changeDetector, toastr, modalService);
  }

  ngOnInit(): void {
    this.model[FormFieldCode.START_DATE] = moment().subtract(7, 'days').format('YYYY-MM-DD');
    this.model[FormFieldCode.END_DATE] = moment().format('YYYY-MM-DD');
    this.tableColumnsSummaryAgent = buildTableColumnsSummaryAgent();
    this.getSummary(this.model);
  }

  getSummary(model: any) {
    const query: GetSummaryQuery = {
      start_date: model[FormFieldCode.START_DATE],
      end_date: model[FormFieldCode.END_DATE],
    };

    Observable.forkJoin([
      this.smartQCService.getSummaryCall(query),
      this.smartQCService.getSummaryEmotion(query),
      this.smartQCService.getSummaryAgent(query),
    ])
      .finally(() => {
        this.loading = false;
        // this.generateEmotionChartOptions(mockDataQCSummaryEmotion());
      })
      .subscribe(
        results => {
          const [qcSummaryCallResponse, qcSummaryEmotionResponse, qcSummaryAgentResponse] = results;

          this.viewQCSummaryCall = buildQCSummaryCall(qcSummaryCallResponse.data as QCSummaryCall);

          this.qcSummaryAgent = qcSummaryAgentResponse.data as QCSummaryAgent[];
          this.viewQcSummaryEmotion = (qcSummaryEmotionResponse.data as QCSummaryEmotion[]).map(qcSummaryEmotion =>
            buildViewQCSummaryEmotion(qcSummaryEmotion)
          );

          this.generateEmotionChartOptions(this.viewQcSummaryEmotion);
        },
        error => {
          console.log('error: ', error);

          this.throwError(error.message);
        }
      );
  }

  generateEmotionChartOptions(viewQCSummaryEmotion: any) {
    const totalCount = sumBy(viewQCSummaryEmotion, (x: any) => x.count);
    this.viewQcSummaryEmotion = viewQCSummaryEmotion.map((value: any, index: number) => {
      return {
        name: value.label,
        count: value.count,
        bg: this.colorsOptionsSourceName[index],
        percentage: round((value.count / totalCount) * 100, 2),
      };
    });

    this.emotionChartOptions = viewQCSummaryEmotion.map((e: any) => ({
      name: e.name,
      percentage: e.percentage,
    }));

    const emotionChartOptionsElement = document.getElementById('emotionChartOptions');
    const widthMotionChartOptions = emotionChartOptionsElement ? emotionChartOptionsElement.offsetWidth : 200;

    this.emotionChartOptions = {
      credits: {
        enabled: false,
      },
      xAxis: {
        type: 'category',
        labels: {
          rotation: -45,
          style: {
            fontSize: '13px',
            fontFamily: 'Verdana, sans-serif',
          },
        },
      },
      yAxis: {
        min: 0,
        title: {
          text: '   ',
        },
      },
      chart: {
        type: 'pie',
        height: 450,
        width: ((widthMotionChartOptions / 2) * 80) / 100,
      },
      title: {
        text: ` `,
      },
      plotOptions: {
        pie: {
          innerSize: '100%',
          dataLabels: {
            enabled: false,
            format: '<b>{point.name}</b>: {point.percentage:.1f} %',
          },
        },
      },
      series: [
        {
          name: '',
          colorByPoint: true,
          data: this.emotionChartOptions,
        },
      ],
      colors: this.colorsOptionsSourceName,
      subtitle: {
        text: `<div>
                  <div>
                  ${totalCount}
                  </div>
                </div>`,
        useHTML: true,
        align: 'center',
        verticalAlign: 'middle',
        y: 0,
        style: {
          fontSize: '30px',
          fontWeight: 'bold',
          color: '#000000',
        },
      },
      tooltip: {
        pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>',
      },
    };
  }

  handleCloseModal() {
    this.modalAction = 'close';
    this.closeModal();
  }

  handleOpenModal() {
    this.modalAction = 'open';
    this.model = {
      [FormFieldCode.START_DATE]: moment().subtract(7, 'days').format('YYYY-MM-DD'),
      [FormFieldCode.END_DATE]: moment().format('YYYY-MM-DD'),
    };

    this.modelContent = {
      type: ModalType.Primary,
      title: 'Chọn ngày',
      submit_title: 'Tìm kiếm',
      close_title: 'Hủy bỏ',
    };

    this.modelDisplay = [
      {
        key: FormFieldCode.START_DATE,
        label: 'Thời gian bắt đầu',
        type: FormFieldType.Datepicker,
        value: this.model[FormFieldCode.START_DATE],
        required: false,
        disabled: false,
        width: '1/2',
        order: 8,
        placeholder: 'Thời gian bắt đầu',
        options: {
          placement: 'right',
        },
      },
      {
        key: FormFieldCode.END_DATE,
        label: 'Thời gian kết thúc',
        type: FormFieldType.Datepicker,
        value: this.model[FormFieldCode.END_DATE],
        required: false,
        disabled: false,
        width: '1/2',
        order: 9,
        placeholder: 'Thời gian kết thúc',
        options: {
          placement: 'right',
        },
      },
    ];

    this.openModal(
      this.template,
      {
        backdrop: true,
        ignoreBackdropClick: true,
        class: 'modal-xl',
        keyboard: false,
      },
      {},
      {
        modelContent: this.modelContent,
        modelDisplay: this.modelDisplay,
      }
    );
  }

  async handleSubmit(model: any) {
    this.getSummary(model);
  }

  onChangeValueModel(fieldCode: FormFieldCode, formModel: any) {
    console.log('Field Code: ', fieldCode);
    this.model = formModel;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/smart-qc/summary/summary.component.ts